import React from 'react';
import { styled } from '../css/styled';
import { Pressable as NativePressable, Platform } from 'react-native';
const StyledPressable = styled(NativePressable)(({ showCursor }) => ({
    ...Platform.select({
        web: {
            cursor: showCursor ? 'pointer' : 'default',
        },
    }),
}));
export const Pressable = React.forwardRef(function Pressable(props, ref) {
    return (<StyledPressable showCursor={!!(props.onPress ||
            props.accessibilityRole === 'link' ||
            !props.disabled)} {...props} ref={ref}>
      {props.children}
    </StyledPressable>);
});
//# sourceMappingURL=pressable.js.map